import { useQuery } from "@apollo/client";
import React, { useState } from "react";
import { Card, Spinner } from "react-bootstrap";
import { useSearchParams } from "react-router-dom";

import ReportListTable from "../../../components/reportListTable";
import QUERY from "../../../utils/service/query";

const ReportList: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const page = parseInt(searchParams.get("page") || "1");
  const limit = parseInt(searchParams.get("limit") || "10");
  const searchQuery = searchParams.get("search") || "";
  const userTypeQuery = searchParams.get("userType") || "";
  const column = searchParams.get("column") || "createdOn";
  const order = searchParams.get("order") || "desc";

  let variables: any = {
    page: page,
    limit: limit,
    searchQuery: searchQuery.toUpperCase(),
    ownerType: userTypeQuery,
    column: column === "reportId" ? "createdOn" : column,
    order: order,
  };
  Object.keys(variables).forEach(
    (k) => variables[k] === "" && delete variables[k],
  );
  const { data, loading, error } = useQuery(QUERY.REPORTS.GET_REPORTS, {
    fetchPolicy: "no-cache",
    variables: variables,
  });
  const res1 = useQuery(QUERY.REPORTS.GET_WEEKLY_RESPONSE_TIME);

  return (
    <>
      <Card className="">
        <Card.Header>
          <h5>Report List</h5>
        </Card.Header>
        <Card.Body className="bg-light">
          {(loading || res1?.loading) && (
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          )}
          {data?.reportsList && res1?.data?.getWeeklyAvgResponseTime && (
            <ReportListTable
              page={page}
              limit={limit}
              totalCount={data?.reportsList?.totalCount || 1}
              searchQuery={searchQuery}
              userTypeQuery={userTypeQuery}
              data={data?.reportsList || []}
              weeklyAvgResTime={res1?.data?.getWeeklyAvgResponseTime}
            />
          )}
          {(error || res1?.error) && <p>Something went wrong!</p>}
        </Card.Body>
      </Card>
    </>
  );
};

export default ReportList;
